module.exports = __webpack_public_path__ + "static/media/marble.37bcdf04.jpg";